var map = {
	"./axess.png": "384f",
	"./bankkartcombo.png": "dfd1",
	"./bonus.png": "7bb5",
	"./garanti.png": "49b8",
	"./isbank.png": "7c2f",
	"./maximum.png": "8843",
	"./qnbfinans.png": "49e0",
	"./qnbfinansbank.png": "452d",
	"./vakifbank.png": "8327",
	"./vakifkalitim.png": "518f",
	"./world.png": "62b4",
	"./yapikredi.png": "ab63",
	"./ziraat.png": "d69e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8761";